import { ContentStrategy, ContentStrategyType, Source, Theme, WeekDay } from 'types'
import { ContentTypeCounts } from 'utils/brandPlans/contentCategories'

export interface GeneratedTheme extends Theme {
  content_brief?: string
  goal_alignment?: string
  strategic_role?: string
  seasonal_tie_in?: string
  call_to_action?: string
  audience?: string[]
  image_description?: string
}

export type SourceRole = 'source_material' | 'visual_asset'

export interface CampaignSource {
  source: Source
  roles: SourceRole[]
  mediaFileId?: number
}

export interface CampaignRow {
  theme: GeneratedTheme
  startDate: string
  endDate: string
  length: number
  weekDays: WeekDay[]
  sources: CampaignSource[]
  loading?: boolean
}

export enum StateId {
  SelectStrategy = 'selectStrategy',
  ContentTypeDefaults = 'contentTypeDefaults',
  ReviewDetails = 'reviewDetails',
  Creating = 'creating',
}

export enum EventId {
  Next = 'NEXT',
  SetContentTypes = 'SET_CONTENT_TYPES',
  ThemeResolved = 'THEME_RESOLVED',
  Back = 'BACK',
  Create = 'CREATE',
  Error = 'ERROR',
}

export interface MachineContext {
  strategyType: ContentStrategyType | null
  strategyConfig: ContentStrategy | null
  campaignCount: number
  campaigns: CampaignRow[]
  contentTypeCounts: ContentTypeCounts | null
  transient: {
    abortController: AbortController
  }
}

export type MachineEvent =
  | {
      type: EventId.Next
      strategyType: ContentStrategyType
      strategyConfig: ContentStrategy
      campaignCount: number
    }
  | {
      type: EventId.SetContentTypes
      counts: ContentTypeCounts
    }
  | {
      type: EventId.ThemeResolved
      index: number
      theme: GeneratedTheme
    }
  | { type: EventId.Back }
  | { type: EventId.Create; campaigns: CampaignRow[] }
  | { type: EventId.Error; error: Error }

export type MachineState =
  | { value: StateId.SelectStrategy; context: MachineContext }
  | { value: StateId.ContentTypeDefaults; context: MachineContext }
  | { value: StateId.ReviewDetails; context: MachineContext }
  | { value: StateId.Creating; context: MachineContext }
